import React, { Fragment, useState, useEffect } from 'react';
import { Container, Alert, Table } from 'react-bootstrap';
import UserService from '../../../../services/user'
import User from './user';
import FormBusca from './busca';
import '../../../../styles/diario.scss';
import { Navigate } from 'react-router-dom';

const UsersScreen = () => {

    const [users, setUsers] = useState([]);
    const [usersOriginais, setUsersOriginais] = useState([]);
    const [editar, setEditar] = useState(false);
    const [senha, setSenha] = useState(false);
    const [vazio, setVazio] = useState(false);
    const [user, setUser] = useState("");

    async function fetchUsers() {
        const response = await UserService.listar();
        if (response.data.length >= 1) {
            setUsers(response.data);
            setUsersOriginais(response.data);
            setVazio(false);
        } else {
            setUsers([]);
            setUsersOriginais([]);
            setVazio(true);
        }
    }

    const filtrarLocalmente = (nome) => {

        // Se todos vazios → voltar ao original
        if (!nome.trim()) {
            setUsers(usersOriginais);
            setVazio(false);
            return;
        }

        const filtrados = usersOriginais.filter(f => {
            const matchNome = nome.trim()
                ? f.nome.toLowerCase().includes(nome.toLowerCase())
                : true;
            return matchNome;
        });

        if (filtrados.length >= 1) {
            setUsers(filtrados);
            setVazio(false);
        } else {
            setUsers([]);
            setVazio(true);
        }
    };

    const handleEditar = (id) => {
        setUser(id);
        setEditar(true)
    }

    const handleSenha = (id) => {
        setUser(id);
        setSenha(true)
    }

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja excluir o usuário?')) {
            try {
                await UserService.deletar(id)
                alert("Usuário deletado com sucesso!")
                fetchUsers();
            } catch (err) {
                alert("Algo deu errado ao deletar a usuário!")
            }
        }
    }

    useEffect(() => {
        fetchUsers();
    }, []);

    if (editar) {
        return (
            <Navigate to={`/ti/user/editar/${user}`} />
        )
    } else if (senha) {
        return <Navigate to={`/ti/user/senha/${user}`} />;
    }
    else {
        return (
            <Fragment>
                <Container>
                    <Fragment>
                        <FormBusca
                            fetchUsers={fetchUsers}
                            filtrarLocalmente={filtrarLocalmente}
                        />
                    </Fragment>
                    {vazio ? <Fragment>
                        <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                    </Fragment> :
                        <Fragment>
                            <br />
                            <Table className="table table-bordered tabela-rh">
                                <thead>
                                    <tr>
                                        <th>Usuário</th>
                                        <th>Nível</th>
                                        <th>E-mail</th>
                                        <th>Editar</th>
                                        <th>Trocar Senha</th>
                                        <th>Excluir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {users.map((user, index) =>
                                        <User
                                            fetchUsers={fetchUsers}
                                            user={user}
                                            key={index}
                                            editar={handleEditar}
                                            senha={handleSenha}
                                            deletar={deletar}
                                        />
                                    )}
                                </tbody>
                            </Table>
                        </Fragment>}
                </Container>
            </Fragment>

        )
    }
}

export default UsersScreen;